import api from "../../../utils/api"
import { download_file } from "../../../utils/general";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import {
    BULK_UPDATE_AUTOMATION_STATUS,
    BULK_UPDATE_AUTOMATION_STATUS_ERROR,
    GET_AUTOMATION_BULK_ACTION_LIST, 
    GET_AUTOMATION_BULK_ACTION_LIST_ERROR, 
    GET_AUTOMATION_LOG_LIST, 
    GET_AUTOMATION_LOG_LIST_ERROR, 
    GET_AUTOMATION_PAY_PERIOD_LIST,
    GET_AUTOMATION_PAY_PERIOD_LIST_ERROR,
    GET_AUTOMATION_RESULT_DETAILS,
    GET_AUTOMATION_RESULT_DETAILS_ERROR,
    GET_PROCESS_LIST,
    GET_PROCESS_LIST_ERROR,
    RESET_AUTOMATION_DETAIL,
    RESET_PROCESS_FLAG,
    RESET_PROCESS_FLAG_ERROR
} from "../types";

export const get_automation_pay_period_list = () => async (dispatch) => {
    try {
        const res = await api.get('api/sub-automation/get-payperiod-list');
        dispatch({
            type: GET_AUTOMATION_PAY_PERIOD_LIST,
            payload: res.data
        });
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, 'danger'));
        }
        dispatch({ type: GET_AUTOMATION_PAY_PERIOD_LIST_ERROR });
    }
}
export const get_process_list = () => async (dispatch) => {
    try {
        const res = await api.get('api/sub-automation/get-process-list');
        dispatch({
            type: GET_PROCESS_LIST,
            payload: res.data
        })
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, 'danger'));
        }
        dispatch({ type: GET_PROCESS_LIST_ERROR });
    }
}
export const generate_invoices_payrecords_payments = (process) => async (dispatch) => {
    try {
        const res = await api.post('api/sub-automation/generate-invoices-payrecords-payments', process);
        dispatch(setAlert(res.data.message, 'success'));
        return true;
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, 'danger'));
        }
        return false;
    }
}

export const get_automation_process_list = (refNum, processIds, payscheduleIds, startDate, endDate) => async (dispatch) => {
    try {
        const res = await api.get('api/sub-automation/get-automation-log-list', {
            params: {
                refNum: refNum,
                processNames: processIds,
                payScheduleNames: payscheduleIds,
                startDate: startDate,
                endDate: endDate,
            }
        });
        dispatch({
            type: GET_AUTOMATION_LOG_LIST,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: GET_AUTOMATION_LOG_LIST_ERROR });
    }
}

export const get_automation_process_details = (
    resultRefNum,
    refNum,
    description,
    type,
    payperiods,
    status,
    currencies,
    startDate,
    endDate
) => async (dispatch) => {
    try {
        const res = await api.get('api/sub-automation/get-automation-result', {
            params: {
                resultRefNum: resultRefNum,
                refNum: refNum,
                description: description,
                type: type,
                payperiods: payperiods,
                status: status,
                currencies: currencies,
                startDate: startDate,
                endDate: endDate,
            }
        });
        dispatch({
            type: GET_AUTOMATION_RESULT_DETAILS,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: GET_AUTOMATION_RESULT_DETAILS_ERROR });
    }
}

export const reset_automation_detail = () => async (dispatch) => dispatch({ type: RESET_AUTOMATION_DETAIL })

export const reset_process_flag = (resultRefNum, overrideCancel) => async (dispatch) => {
    try {
        const res = await api.get('api/sub-automation/reset-process-flag', {
            params: {
                resultRefNum: resultRefNum,
                overrideCancel: overrideCancel,
            }
        });
        dispatch({
            type: RESET_PROCESS_FLAG,
            payload: res.data
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: RESET_PROCESS_FLAG_ERROR });
        return false;
    }
}

export const get_automation_bulk_action_list = () => async (dispatch) => {
    try {
        const res = await api.get('api/sub-automation/get-bulk-action');
        dispatch({
            type: GET_AUTOMATION_BULK_ACTION_LIST,
            payload: res.data
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: GET_AUTOMATION_BULK_ACTION_LIST_ERROR });
    }
}

export const download_automation_results = (refNums) => async (dispatch) => {
    try {
        const res = await api.post(`api/sub-automation/download-automation-results`, refNums, {
            responseType: 'blob'
        });

        const contentDisposition = res.headers.get('Content-Disposition');
        let filename = 'downloaded_automation' + '.pdf';
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (filenameMatch.length === 2) {
                filename = filenameMatch[1];
            }
        }
        download_file(res.data, filename)
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, "danger"));
        }
    }
}

export const bulk_update_automation_status = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/sub-automation/bulk-update-automation-results-status`, bulkData)
        dispatch({
            type: BULK_UPDATE_AUTOMATION_STATUS
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        const success = err.response.data.success;
        if (!success) {
            dispatch(setAlert(err.response.data.message, 'danger'))
        }
        dispatch({
            type: BULK_UPDATE_AUTOMATION_STATUS_ERROR
        })
        return false;
    }
}
